import React from 'react';
import Head from 'next/head';
import getConfig from 'next/config';

import {utcToIso8601} from '~/src/utilities/helpers/date';

import {Variants} from '~/src/types/image';
import {Author, Tag} from '~/src/types/meta';
import {VideoCmsItem} from '~/src/types/feed/content';

const {publicRuntimeConfig: config} = getConfig();

interface StructuredVideoProps {
    name: string;
    description: string;
    thumbnails: Variants;
    authors?: Author[];
    tags?: Tag[];
    mainCategoryName: string;
    datePublished: string;
    video: VideoCmsItem;
    commentCount?: number;
    isLive: boolean;
}

const thumbnailVariants = ['fix1200x1200px', 'fix1200x900px', 'fix1200x675px'];

const StructuredVideo = ({
    name,
    description,
    thumbnails,
    authors = [],
    tags = [],
    mainCategoryName,
    datePublished,
    video,
    commentCount,
    isLive
}: StructuredVideoProps) => {
    const author = authors.length
        ? authors.map((item) => ({
              '@type': 'Person',
              name: item.name
          }))
        : {'@type': 'NewsMediaOrganization', name: config.tenantName};

    const thumbnailUrl = thumbnails && thumbnailVariants.filter((variant) => thumbnails[variant]).map((variant) => thumbnails[variant].src);

    const publication = {
        '@type': 'BroadCastEvent',
        isLiveBroadcast: isLive
    };

    const structuredData = {
        '@context': 'http://schema.org',
        '@type': 'VideoObject',
        name,
        description,
        thumbnailUrl,
        author,
        keywords: tags.map((keyword) => keyword.name),
        genre: [mainCategoryName],
        uploadDate: utcToIso8601(datePublished),
        duration: `PT${video.duration}S`,
        contentUrl: video.url_high,
        embedUrl: `${config.embedUrls.videoPlayer}?videoId=${video.video_id}&lang=${config.language}`,
        commentCount,
        publication
    };

    return (
        <Head>
            <script key="structuredVideo" type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(structuredData)}}></script>
        </Head>
    );
};

export default StructuredVideo;
